import { Navigate, Route, Routes } from 'react-router-dom';
import AdminPage from './pages/AdminPage';
import AudiencePage from './pages/AudiencePage';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ChangePasswordPage from './pages/ChangePasswordPage';
import DossierDetailPage from './pages/DossierDetailPage';
import DossiersPage from './pages/DossiersPage';
import ExternalApp from './pages/ExternalApp';
import LoginPage from './pages/LoginPage';
import PdfEditorPage from './pages/PdfEditorPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Sprint B / ADR-019 — Sous-app externe isolée. Pas de Layout
          M24, pas de ProtectedRoute (auth gérée en interne via
          sessionStorage). Toujours catch-all sur /external/*. */}
      <Route path="/external/*" element={<ExternalApp />} />
      <Route element={<ProtectedRoute />}>
        {/* Mode Audience : route directe sans Layout (plein écran tablette). */}
        <Route path="/dossiers/:id/audience" element={<AudiencePage />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/dossiers" replace />} />
          <Route path="/dossiers" element={<DossiersPage />} />
          {/* Routes plus spécifiques d'abord — `/dossiers/:id/*` ci-dessous
              catch tout le reste (5 onglets top-level + sous-onglets). */}
          <Route path="/dossiers/:id/pieces/:pdfId" element={<PdfEditorPage />} />
          <Route path="/dossiers/:id/pieces-client/:pcId" element={<PdfEditorPage />} />
          {/* Sprint F1 viewer multi-bucket (2026-05-23) — pièces adverses */}
          <Route path="/dossiers/:id/pieces-adverses/:paId" element={<PdfEditorPage />} />
          {/* Sprint F1 phase 2 (2026-05-23) — other documents + conclusions déposées */}
          <Route path="/dossiers/:id/other-documents/:odId" element={<PdfEditorPage />} />
          <Route path="/dossiers/:id/conclusion-files/:cfId" element={<PdfEditorPage />} />
          <Route path="/dossiers/:id/*" element={<DossierDetailPage />} />
          <Route path="/account/password" element={<ChangePasswordPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
